
import { useEffect } from 'react';
import { SimulationConfig } from '@/types';

export const useWindowAPI = (
    update: (dt: number) => void,
    initSimulation: (reset?: boolean) => void,
    setConfig: React.Dispatch<React.SetStateAction<SimulationConfig>>,
    setShowUI: (show: boolean) => void,
    audioService: any,
    audioUtils: any
) => {
  useEffect(() => {
    (window as any).setConfig = setConfig;
    (window as any).setShowUI = setShowUI;
    (window as any).stepSimulation = (dt: number) => {
        update(dt);
    };
    (window as any).startOfflineAudioRender = async (durationSec: number) => {
        const sampleRate = 44100;
        const offlineCtx = new OfflineAudioContext(2, sampleRate * durationSec, sampleRate);
        audioService.setContext(offlineCtx);
        initSimulation();
        return { offlineCtx };
    };
    (window as any).finishOfflineAudioRender = async (offlineCtx: OfflineAudioContext) => {
        const renderedBuffer = await offlineCtx.startRendering();
        const wavBlob = audioUtils.audioBufferToWav(renderedBuffer);
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(wavBlob);
        });
    };
    
    return () => {
        delete (window as any).setConfig;
        delete (window as any).setShowUI;
        delete (window as any).stepSimulation;
        delete (window as any).startOfflineAudioRender;
        delete (window as any).finishOfflineAudioRender;
    };
  }, [setConfig, setShowUI, update, initSimulation, audioService, audioUtils]);
};
